import { defineComponent as _defineComponent } from 'vue';
import { BCard, BCollapse, BFormCheckbox, BFormGroup, BFormSelect, BLink } from "bootstrap-vue";
import { computed, reactive, ref } from "vue";
import { AVAILABLE_EXPORT_FORMATS } from "@/api/histories.export";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExportOptions',
    props: {
        exportParams: null
    },
    emits: ["onValueChanged"],
    setup(__props, { emit }) {
        const props = __props;
        const isExpanded = ref(false);
        const title = computed(() => (isExpanded.value ? `Hide advanced export options` : `Show advanced export options`));
        const localOptions = reactive({
            modelStoreFormat: props.exportParams.modelStoreFormat,
            includeFiles: props.exportParams.includeFiles,
            includeDeleted: props.exportParams.includeDeleted,
            includeHidden: props.exportParams.includeHidden,
        });
        function onValueChanged() {
            emit("onValueChanged", localOptions);
        }
        return { __sfc: true, props, emit, isExpanded, title, localOptions, onValueChanged, BCard, BCollapse, BFormCheckbox, BFormGroup, BFormSelect, BLink, AVAILABLE_EXPORT_FORMATS };
    }
});
